"use strict";

var _interopRequireDefault = require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _mixin = _interopRequireDefault(require("@/utils/mixin"));
var _room = require("@/api/room");
var _moment = _interopRequireDefault(require("moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "HotelIndex",
  mixins: [_mixin.default],
  data: function data() {
    return {
      hotelList: [],
      listQuery: {
        hotel_id: "",
        day: ""
      },
      list: [],
      listLoading: false,
      fixedColumns: [{
        label: "房型",
        keyword: "name",
        width: 220,
        fixed: "left"
      }
      // { label: "当前房态", keyword: "sale_status", width: 120, fixed: "left" },
      ],

      columns: [],
      chooseRoomDayStock: -1,
      dialogStockFormVisible: false,
      stockForm: {
        id: "",
        day: "",
        stock: 0
      },
      stockFormRules: {
        // stock: [{ required: true, message: '请输入库存', trigger: 'blur' }],
      },
      stockFormConfirmLoading: false
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 初始化时间
              this.listQuery.day = (0, _moment.default)().format("YYYY-MM-DD");
              this.resetColmuns();
              // 获取支持房情操作的酒店
              _context.next = 4;
              return (0, _room.getRoomStatHotels)();
            case 4:
              res = _context.sent;
              this.hotelList = res.data;
              this.listQuery.hotel_id = this.hotelList[0].id;
              // 拉取数据
              this.getList();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    formatDay: function formatDay(todayMoment) {
      if (typeof todayMoment == 'string') {
        todayMoment = (0, _moment.default)(todayMoment);
      }
      var date = todayMoment.format("MM/DD");
      var week = parseInt(todayMoment.format("d"));
      if (week == 1) {
        week = '周一';
      } else if (week == 2) {
        week = '周二';
      } else if (week == 3) {
        week = '周三';
      } else if (week == 4) {
        week = '周四';
      } else if (week == 5) {
        week = '周五';
      } else if (week == 6) {
        week = '周六';
      } else {
        week = '周日';
      }
      return "".concat(date, "\uFF08").concat(week, "\uFF09");
    },
    resetColmuns: function resetColmuns() {
      // 更新表头
      var startDate = (0, _moment.default)(this.listQuery.day);
      var dayColmuns = [];
      for (var i = 0; i < 7; i++) {
        dayColmuns.push({
          label: this.formatDay(startDate),
          width: 245,
          keyword: startDate.format("YYYY-MM-DD")
        });
        startDate = startDate.add(1, "days");
      }
      this.columns = JSON.parse(JSON.stringify(this.fixedColumns)).concat(dayColmuns);
    },
    getList: function getList() {
      var _this = this;
      this.resetColmuns();
      this.listLoading = true;
      (0, _room.getRoomStat)(this.listQuery.hotel_id, this.listQuery).then(function (response) {
        _this.list = response.data;
        _this.listLoading = false;
      });
    },
    paserStatus: function paserStatus(record) {
      if (record.close) {
        return '<span style="color:#909399">隐藏</span>';
      }
      var dayStock = record.stocks[this.listQuery.day];
      if (dayStock.remain_num == 0) {
        return '<span style="color:#F56C6C">满房</span>';
      }
      return '<span style="color:#67C23A">可售</span>';
    },
    paserStock: function paserStock(stock) {
      if (stock == undefined) {
        return;
      }
      // if (stock.close) {
      //   return `<div style="text-align: center;"><span style="color:#F56C6C">已关房</span></div>`
      // }
      var str = "";
      var breakStr = "<span style=\"margin: 0 8px;\">/</span>";
      if (stock.total == -1) {
        str += "<span>\u603B\u5E93\u5B58\uFF1A\u672A\u8BBE\u7F6E</span>";
      } else {
        str += "<span>\u603B\u5E93\u5B58\uFF1A".concat(stock.total, "</span>");
      }
      str += breakStr;
      if (stock.remain_num == -1) {
        str += "<span>\u53EF\u552E\uFF1A\u672A\u8BBE\u7F6E</span>";
      } else if (stock.remain_num > 0) {
        str += "<span>\u53EF\u552E\uFF1A<span style=\"color:#67C23A\">".concat(stock.remain_num, "</span></span>");
      } else {
        str += "<span>\u53EF\u552E\uFF1A<span style=\"color:#F56C6C\">".concat(stock.remain_num, "</span></span>");
      }
      str += breakStr;
      str += "<span>\u5DF2\u552E\uFF1A".concat(stock.sale_num, "</span>");
      return "<div style=\"text-align: left;\">".concat(str, "</div>");
    },
    closeHandler: function closeHandler(roomId) {
      var _this2 = this;
      (0, _room.closeRoom)(roomId).then(function (res) {
        _this2.$message.success("操作成功");
        _this2.getList();
      });
    },
    setRoomStatHandler: function setRoomStatHandler(roomId, isOpen, day) {
      var _this3 = this;
      var data = {
        open: isOpen ? 1 : 0,
        date: [day, day]
      };
      (0, _room.setRoomStat)(roomId, data).then(function (res) {
        _this3.$message.success("操作成功");
        _this3.getList();
      });
    },
    stockChangeHandler: function stockChangeHandler(record, day) {
      this.chooseRoomDayStock = record.stocks[day].total;
      this.stockForm.id = record.id;
      this.stockForm.day = day;
      this.stockForm.stock = '';
      this.dialogStockFormVisible = true;
    },
    stockFormCloseHanlder: function stockFormCloseHanlder() {
      this.$refs.stockForm.resetFields();
    },
    stockFormSubmitHandler: function stockFormSubmitHandler() {
      var _this4 = this;
      this.$refs['stockForm'].validate(function (valid) {
        if (valid) {
          _this4.stockFormConfirmLoading = true;
          (0, _room.setRoomStock)(_this4.stockForm.id, {
            date: [_this4.stockForm.day, _this4.stockForm.day],
            stock: _this4.stockForm.stock
          }).then(function (res) {
            _this4.$message.success("编辑成功");
            _this4.stockFormConfirmLoading = false;
            _this4.dialogStockFormVisible = false;
            _this4.getList();
          }).catch(function () {
            _this4.stockFormConfirmLoading = false;
          });
        }
      });
    }
  }
};
exports.default = _default;